import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EventDatePipe } from './pipes/event-due-date.pipe';
import { EventIconPipe } from './pipes/event-icon.pipe';
import { EventDetailsFormatPipe } from './pipes/event-details-format.pipe';
import { SparkCoreModule } from '@core/core.module';
import { LoadModule } from '@shared/components/load/load.module';
import { MenuModule } from '@shared/components/menu/menu.module';
import { SparkPlusModalModule } from '@shared/components/modal/modal.module';
import { SharedModule } from '@shared/shared.module';
import { EventListComponent } from './views/list/event-list.component';
import { EventDetailsComponent } from './views/details/event-details.component';

@NgModule({
  declarations: [
    EventListComponent,
    EventDetailsComponent,
    EventDatePipe,
    EventDetailsFormatPipe,
    EventIconPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    LoadModule,
    SparkPlusModalModule,
    LoadModule,
    MenuModule,
    SparkCoreModule
  ],
  exports: [
    EventListComponent,
    EventDetailsComponent,
    EventDatePipe,
    EventDetailsFormatPipe
  ],
  providers: [EventDetailsFormatPipe]
})
export class EventsModule {}
